import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { changeNumberColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getChangeNumber } from "../../../../api/sim";

const COPY_KEYS = ["id", "iccid", "status", "zipcode", "old_msisdn", "new_msisdn"];

const ChangeNumberBatch = () => (
  <BatchDetail
    title="Change Number"
    apiGet={__getChangeNumber}
    client={CLIENTS.pwg}
    columnsFactory={(ctx) =>
      changeNumberColumns({
        ...ctx,
        iccidHeaderName: "SIM/ESN",
        newMsisdnHeaderName: "New MDN",
        oldMsisdnHeaderName: "Old MDN",
      })
    }
    copyKeys={COPY_KEYS}
    exportAction="change_number"
    retryOperation="change_number"
    showTerminate
    getRowPath={(row) => `/pwg/change_number/${row.id}`}
  />
);

export default ChangeNumberBatch;
